export interface IInvoice {
  id: number
  status: string
  file_url: string
  total_containers: number
  total_miners: number
  total: number
  work_order_number: string
  customer: { id: number; name: string }
}

export interface IInvoiceContainerMinerFees {
  part_type: string
  failure_type: string | null
  comment: string | null
  action: string
  price: number
}

export interface IInvoiceContainerMiner {
  id: number
  sn: string
  model: string
  total: number
  fees: IInvoiceContainerMinerFees[]
}

export interface IInvoiceContainer {
  number: string
  total_miners: number
  total: number
  miners: IInvoiceContainerMiner[]
}

export interface IInvoiceSummaryRow {
  quantity: number
  description: string
  unit_cost: number
  total: number
}

export interface IInvoiceDetails {
  status: InvoiceStatus
  file_url: string
  customer: string
  work_order: string
  containers: IInvoiceContainer[]
  summary: IInvoiceSummaryRow[]
}

export interface IInvoiceCreationForm {
  work_order_number: string
  container_ids: number[]
}

export enum InvoiceStatus {
  READY_TO_SEND = 'Ready to Send',
  SENT = 'Sent',
  PAYMENT_LATE = 'Payment Late',
  PAID = 'Paid',
}

export interface IInvoiceUpdateForm {
  status: InvoiceStatus
}
